import { useEffect, useState } from 'react';
import { api } from '../api';
import { Footer, TopBar } from '../components/TopBar';

export function Static({ slug }: { slug: string }) {
  const [page, setPage] = useState<{ title: string; html: string } | null>(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setPage(null);
    setMissing(false);
    api
      .get<{ title: string; html: string }>(`/pages/${slug}`)
      .then(setPage)
      .catch(() => setMissing(true));
  }, [slug]);

  useEffect(() => {
    document.title = page ? `${page.title} — The Yard Sale Map` : 'The Yard Sale Map';
  }, [page]);

  return (
    <>
      <TopBar />
      <main className="page" id="main">
        {missing ? (
          <>
            <h1>Page not found</h1>
            <p>
              <a href="/">Back to the map</a>
            </p>
          </>
        ) : page ? (
          <article dangerouslySetInnerHTML={{ __html: page.html }} />
        ) : (
          <p aria-live="polite">Loading…</p>
        )}
      </main>
      <Footer />
    </>
  );
}
